import "core-js/modules/es.array.map";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import ProductParametersListItemGroup from '../ProductParametersListItemGroup';
var useStyles = makeStyles(function () {
  return {
    root: {
      width: '100%'
    }
  };
}, {
  name: 'SxComProductParametersList'
});

function ProductParametersList(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      parameterGroups = _ref.parameterGroups,
      rest = _objectWithoutProperties(_ref, ["classes", "className", "parameterGroups"]);

  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className)
  }), parameterGroups.map(function (_ref2) {
    var code = _ref2.code,
        helperText = _ref2.helperText,
        label = _ref2.label,
        parameters = _ref2.parameters;
    return /*#__PURE__*/React.createElement(ProductParametersListItemGroup, {
      key: code,
      helperText: helperText,
      label: label,
      parameters: parameters
    });
  }));
}

ProductParametersList.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string
  }),
  className: PropTypes.string,
  parameterGroups: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string.isRequired,
    helperText: PropTypes.string,
    label: PropTypes.string.isRequired,
    parameters: PropTypes.arrayOf(PropTypes.shape({
      helperText: PropTypes.string,
      label: PropTypes.string.isRequired,
      unit: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
    }))
  }))
};
ProductParametersList.defaultProps = {
  classes: undefined,
  className: undefined,
  parameterGroups: []
};
export default ProductParametersList;